import { request, type ApiResult } from '@/utils/request'

/**
 * C 端全局功能开关（游客可访问，白名单收口）
 */
export interface AppFeatureFlags {
  /** AI 情感助理入口：1 首页/AI红娘/我的展示悬浮胶囊；0 全部不展示 */
  aiAssistantEnabled: number
}

/**
 * 获取 C 端全局功能开关
 * GET /app/feature-flags（PublicAccess，无需登录）
 * 静默请求：弱网/异常不弹错误 toast，由调用方按默认开启兜底
 */
export function getFeatureFlags(): Promise<ApiResult<AppFeatureFlags>> {
  return request.getSilent<AppFeatureFlags>('/app/feature-flags')
}
